import { LogoMark } from "./Logo";

export const ConnectState = ({ compact = false }) => (
  <div
    data-testid="shopify-connect-state"
    className={`border border-dashed border-border text-center ${
      compact ? "p-8" : "p-12 lg:p-20"
    }`}
  >
    <LogoMark className="mx-auto h-8 w-8 opacity-60" />
    <p className="mt-6 font-mono text-xs uppercase tracking-[0.3em] text-signal">
      Awaiting Shopify connection
    </p>
    <h3 className="mt-3 font-display text-xl font-semibold uppercase tracking-tight sm:text-2xl">
      Your live catalog appears here
    </h3>
    <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-muted-foreground">
      The moment your Shopify Storefront API credentials are added, products,
      prices, variants and inventory stream in straight from your store — no
      code changes, nothing hard-coded.
    </p>
  </div>
);
